import React from 'react';
import { useAsync } from 'react-async';
import './App.css';
import './scss/main.scss';

import App from './components/App';

const getLocation = async () => {
  navigator.geolocation.getCurrentPosition(() => {});
  const res = await fetch('https://ipinfo.io/?token=c5a9bb9a7eced1');
  const data = await res.json();

  return data.city;
};

function Start() {
  const { data, error, isLoading } = useAsync({
    promiseFn: getLocation,
  });
  if (error) return 'Error in getting location :(';
  if (isLoading) return 'Loading...';
  if (data) return <App data={data} />;
}

export default Start;
